import React, { useState, useEffect } from "react";

function App() {
  const [otp, setOtp] = useState("");
  const [timestamp, setTimestamp] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchOtp = async () => {
      try {
        const res = await fetch(
          "https://mailosaur.com/api/messages?server=oxrjk2ga",
          {
            method: "GET",
            headers: {
              Authorization:
                "Basic " + btoa("api:UMgQ8YMQXyglqYGjEscGIdGJmMsAQ7Qt"),
              Accept: "application/json",
            },
          }
        );

        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();

        const latest = data.items?.[0];
        if (!latest) {
          setOtp("");
          return;
        }

        // Extract OTP from summary
        let code = "";
        if (latest.summary) {
          const match = latest.summary.match(/\b\d{6,8}\b/);
          code = match ? match[0] : "";
        }

        setOtp(code || "");
        setTimestamp(latest.received);
      } catch (err) {
        console.error(err);
        setError(err.message);
      }
    };

    fetchOtp();
    const id = setInterval(fetchOtp, 15000); // refresh every 15s
    return () => clearInterval(id);
  }, []);

return (
    <div style={{ textAlign: "center", marginTop: 50 }}>
      <h1>Your Latest OTP</h1>
      <h2 style={{ fontSize: "2rem", color: otp ? "green" : "gray" }}>
        {otp || "Waiting for OTP..."}
      </h2>
      {timestamp && (
        <p style={{ color: "gray" }}>
          Received: {new Date(timestamp).toLocaleString()}
        </p>
      )}
      <div
        style={{

          padding: "15px",
          marginTop: "20px",
          fontSize: "14px",
          color: "#333",
          textAlign: "center",
        }}
      >
        
        <br />
       <strong>Disclaimer:</strong> This One-Time Password (OTP) page has been created solely for Apple Inc.
        to review the application and approve it for publishing on the App
        Store. It is not intended for any other use or purpose.
        © Carexa, Inc.
      </div>
    </div>
  );
}

export default App;
